import AddLinkIcon from "@mui/icons-material/AddLink";
import AlignHorizontalCenterIcon from "@mui/icons-material/AlignHorizontalCenter";
import AlignHorizontalLeftIcon from "@mui/icons-material/AlignHorizontalLeft";
import AlignHorizontalRightIcon from "@mui/icons-material/AlignHorizontalRight";
import AlignVerticalBottomIcon from "@mui/icons-material/AlignVerticalBottom";
import AlignVerticalCenterIcon from "@mui/icons-material/AlignVerticalCenter";
import AlignVerticalTopIcon from "@mui/icons-material/AlignVerticalTop";
import ArchiveIcon from "@mui/icons-material/Archive";
import CloseIcon from "@mui/icons-material/Close";
import CommentIcon from "@mui/icons-material/Comment";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import CropIcon from "@mui/icons-material/Crop";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import FlipToBackIcon from "@mui/icons-material/FlipToBack";
import GridOffIcon from "@mui/icons-material/GridOff";
import GridOnIcon from "@mui/icons-material/GridOn";
import ImageIcon from "@mui/icons-material/Image";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import LayersIcon from "@mui/icons-material/Layers";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import NotesIcon from "@mui/icons-material/Notes";
import OpacityIcon from "@mui/icons-material/Opacity";
import PaletteIcon from "@mui/icons-material/Palette";
import RedoIcon from "@mui/icons-material/Redo";
import Rotate90DegreesCwIcon from "@mui/icons-material/Rotate90DegreesCw";
import SelectAllIcon from "@mui/icons-material/SelectAll";
import SubtitlesIcon from "@mui/icons-material/Subtitles";
import UndoIcon from "@mui/icons-material/Undo";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import {
  Backdrop,
  Badge,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Tooltip,
  Typography,
  Grid,
  Tab,
  Tabs,
} from "@mui/material";
import { Editor } from "@tinymce/tinymce-react";
import { Upload } from "antd";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";
import { SimplePrompt } from "components/UpStyled/Prompt";
import Compressor from "compressorjs";
import { AccountContext } from "context/account";
import SharedContentContext from "context/shared-content";
import { StoreContext } from "context/store";
import { nanoid } from "nanoid";
import Comments from "pages/comment";
import NewSharedBar from "pages/de/share-page/newsharebar";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { Layer, Rect, Stage } from "react-konva";
import { Html } from "react-konva-utils";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import api from "services/api";
import { dataURLtoFile, getImageDimensions } from "utils/imageHelper";
import {
  ArchivedView,
  GridLayer,
  MBColor,
  MBImage,
  MBMusic,
  MBText,
  MBVideo,
  ShowColorDialog,
  blockPixels,
  dragHeaderHeight,
  getImageRatio,
  minBlock,
} from "./components/moodboardcomponents";
//import { exportComponentAsPNG } from "react-component-export-image";
import VersionDialog from "components/UpStyled/VersionDialog";
import { TbCopy, TbVersions } from "react-icons/tb";
import { checkPermission } from "utils/helper";
import MoodboardPageTutorialModal from "pages/tutorial/MoodboardPageTutorialModal";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import MoodboardFileList from "pages/de/collection/moodboards/components/MoodboardFileList";
import TabPanel from "components/UpStyled/TabPanel";

import FolderIcon from "@mui/icons-material/Folder";
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";

const Moodboard = ({ sharedView = false }) => {
  var bgcolor = "#EEEFF0"; //"#EBEDEE"
  var isMac = window.navigator?.userAgent?.indexOf("Mac") > 0;
  var deepEqual = require("deep-equal");
  const menuTop = 1;
  const menuFont = "body3";
  const NEW_CHAT_MESSAGE_EVENT = "newChatMessage"; // Name of the event

  const [name, setName] = useState("Moodboard");
  const [sketchWidth, setSketchWidth] = useState(window.innerWidth - 100);
  const [sketchHeight, setSketchHeight] = useState(window.innerHeight - 110);
  const [components, setComponents] = useState([]);
  const [selectedComponentId, setSelectedComponentId] = useState([]);
  const [showColorDialog, setShowColorDialog] = useState(false);
  const [showLinkDialog, setShowLinkDialog] = useState(false);
  const [showGridBg, setShowGridBg] = useState(true);
  const [showCropImageDialog, setShowCropImageDialog] = useState(false);
  const [showCaptionDialog, setShowCaptionDialog] = useState(false);
  const [showTextDialog, setShowTextDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorZoomEl, setAnchorZoomEl] = useState(null);
  const [dragType, setDragType] = useState(null);
  const [bgColor, setBgColor] = useState(bgcolor);
  const [moodboardData, setMoodboardData] = useState({
    name: "Untitled",
    sketch: null,
    mode: 0,
    img: {},
  });
  const [permission, setPermission] = useState(2);
  const [isDirty, setIsDirty] = useState(false);
  const [editNameVisible, setEditNameVisible] = useState(false);
  const [versions, setVersions] = useState([]);
  const [versionDialogVisible, setVersionDialogVisible] = useState(false);
  const [inputWidth, setInputWidth] = useState(20);
  const [uploading, setUploading] = useState(false);
  const [rangeSelection, setRangeSelection] = useState({});
  const [promptConfig, setPromptConfig] = useState(null);
  const [sketchScale, setSketchScale] = useState(1);
  const [areaWidth, setAreaWidth] = useState(0);
  const [areaHeight, setAreaHeight] = useState(0);
  const [contextMenuComponent, setContextMenuComponent] = useState(null);
  const [showArchived, setShowArchived] = useState(false);
  const [tutorialVisible, setTutorialVisible] = useState(false);
  const [showAiDesign, setShowAiDesign] = useState(false);
  const [aiDesignComponents, setAiDesignComponents] = useState([]);
  const [tabValue, setTabValue] = useState("moodboard");
  const [randomSeed, setRandomSeed] = useState();

  const addImageRef = useRef(null);
  const exportImgRef = useRef({});
  const saveCntRef = useRef(0);
  const stageRef = useRef(null);
  const uploadImgPosition = useRef({ x: 0, y: 0 });
  const moodboardNameInputRef = useRef(null);
  const imgRef = useRef();
  const stepHistory = useRef([]);
  const stepHistoryIndex = useRef(0);
  const stepHistoryCheck = useRef(1);
  const componentsRef = useRef(null);
  componentsRef.current = components;
  const sketchScaleRef = useRef(null);
  sketchScaleRef.current = sketchScale;
  const selectedComponentsRef = useRef(null);
  const rightRef = useCallback(async (node) => {
    if (node !== null) {
      await new Promise((res) => setTimeout(res, 50));
      node.focus();
      node.addEventListener(
        "wheel",
        (e) => {
          if (!e.metaKey) return;
          e.preventDefault();
          var deltaY = e.deltaY;
          //console.log('e', e, deltaY)
          if (deltaY > 0) {
            var upperBound =
              sketchScaleRef.current < 0.5
                ? 0.5
                : sketchScaleRef.current < 1
                ? 1
                : sketchScaleRef.current < 2
                ? 2
                : 3;
            if (deltaY > 100) {
              setSketchScale(upperBound);
            } else {
              var delta = Math.max(0.01, (deltaY * sketchScaleRef.current) / 200);
              setSketchScale(Math.min(upperBound, sketchScaleRef.current + delta));
            }
          } else {
            var lowerBound =
              sketchScaleRef.current <= 0.5
                ? 0.25
                : sketchScaleRef.current <= 1
                ? 0.5
                : sketchScaleRef.current <= 2
                ? 1
                : 2;
            if (deltaY < -100) {
              setSketchScale(lowerBound);
            } else {
              var delta = Math.min(-0.01, (deltaY * sketchScaleRef.current) / 200);
              setSketchScale(Math.max(lowerBound, sketchScaleRef.current + delta));
            }
          }
        },
        { passive: false }
      );
    }
  }, []);
  const isDirtyRef = useRef(false);
  isDirtyRef.current = isDirty;

  const { store } = useContext(StoreContext);
  var user_id = store.id;
  const account = useContext(AccountContext);
  const { permissionMap, retrieveContentPermission } = useContext(SharedContentContext);

  const urlParams = new URLSearchParams(window.location.search);
  let moodboard_id = urlParams.get("id");

  const fitBlock = (component) => {
    if (component.archived) return component;
    if (component.x < 1) component.x = 1;
    if (component.y < 1) component.y = 1;
    if (showGridBg) {
      component.x = Math.round(component.x / blockPixels) * blockPixels + 1;
      component.y = Math.round(component.y / blockPixels) * blockPixels + 1;
      var wBlock = Math.max(minBlock, Math.round(component.width / blockPixels));
      component.width = wBlock * blockPixels - 2;
      var hBlock = Math.max(minBlock, Math.round(component.height / blockPixels));
      if (component.type === "image") {
        var ratio = component.freesize
          ? component.height / component.width
          : getImageRatio(component);
        hBlock = Math.round((component.width * ratio) / blockPixels);
      }
      component.height = hBlock * blockPixels - 2;
    } else {
      component.x = Math.round(component.x);
      component.y = Math.round(component.y);
      component.width = Math.max(Math.round(component.width), minBlock * blockPixels - 2);
      if (component.type === "image") {
        var ratio = component.freesize
          ? component.height / component.width
          : getImageRatio(component);
        component.height = Math.round(component.width * ratio);
      }
    }
    return component;
  };

  const loadMoodBoard = async (init = false) => {
    if (!moodboard_id) {
      setPermission(2);
      setComponents([]);
      setVersions([]);
      setSketchScale(1);
      setBgColor(bgcolor);
      setName("Moodboard");
      setPromptConfig(null);
      setMoodboardData({
        name: "Untitled",
        sketch: null,
        mode: 0,
        img: {},
      });
      console.log("reset data");
      return;
    }
    setIsDirty(false);
    api.moodboard
      .get(moodboard_id)
      .then(({ data }) => {
        if (data.moodboard?.owner_id === undefined) {
          setPermission(0);
          return data;
        }
        var perms = data.moodboard?.perms !== undefined ? data.moodboard?.perms : 2;
        if (data.moodboard?.mode && data.moodboard?.mode === 2) perms = 1;
        setPermission(perms);
        if (perms === 0) return;
        setName(data.moodboard.name);
        setMoodboardData(data?.moodboard);
        var sketch = data.moodboard.sketch;
        //console.log('sketch', sketch, bgColor)
        if (sketch?.bgColor) setBgColor(sketch.bgColor);
        if (sketch?.showGridBg !== undefined) setShowGridBg(sketch?.showGridBg);
        if (sketch?.components) setComponents(sketch.components);
        if (sketch?.versions) setVersions(sketch.versions);
        if (init)
          stepHistory.current.push({
            bgColor: sketch?.bgColor ?? bgColor,
            showGridBg: sketch?.showGridBg !== undefined ? sketch?.showGridBg : showGridBg,
            components: sketch?.components ?? components,
          });
        return data;
      })
      .catch((err) => {
        toast.error(`Load moodboard failed!`);
        console.log(err);
      });
  };
  const shareSessionRef = useRef({ refeshfunc: loadMoodBoard });

  const saveMoodBoardImg = async (imageDataFile) => {
    if (!moodboard_id) {
      //do create moodboard
      let value = moodboardNameInputRef?.current?.value || "";
      value = value.trim();

      let payload = {
        name: value || "Untitled",
      };
      const newMoodboard = await api.moodboard.create(payload);
      moodboard_id = newMoodboard?.data?.id;
      window.history.replaceState(
        "",
        "Moodboard",
        `${window.location.pathname}?id=${moodboard_id}`
      );
    }

    let payload = {
      id: moodboard_id,
    };
    if (imageDataFile) {
      const uploadedImg = await api.uploads
        .create([imageDataFile])
        .then(({ data }) => {
          const uploaded = data.uploads.map(({ url }) => url);
          return uploaded;
        })
        .catch((err) => {
          console.log(err);
          toast.error("Save moodboard image failed!");
        });
      if (uploadedImg.length !== 1) return;
      payload.img = { url: uploadedImg[0], type: imageDataFile.type, name: name };
    } else payload.img = "";
    await api.moodboard.update(payload);
  };

  const saveMoodBoard = async () => {
    setIsDirty(false);
    if (permission <= 1) return;
    try {
      if (!moodboard_id) {
        //do create moodboard
        let value = moodboardNameInputRef?.current?.value || "";
        value = value.trim();

        let payload = {
          name: value || "Untitled",
        };
        const newMoodboard = await api.moodboard.create(payload);
        moodboard_id = newMoodboard?.data?.id;
        window.history.replaceState(
          "",
          "Moodboard",
          `${window.location.pathname}?id=${moodboard_id}`
        );
      }

      var ts = new Date().getTime();
      let payload = {
        id: moodboard_id,
        sketch: {
          bgColor: bgColor,
          showGridBg: showGridBg,
          components: components,
          versions: versions,
        },
      };
      await api.moodboard.update(payload);
      console.log("Save moodboard take", new Date().getTime() - ts, "ms");
      shareSessionRef.current.socket?.emit(NEW_CHAT_MESSAGE_EVENT, {
        senderId: user_id,
        sessionId: shareSessionRef.current.id,
        contacts: [],
        dt: new Date(),
      });
      if (stepHistoryCheck.current == 1) {
        stepHistoryIndex.current = stepHistoryIndex.current + 1;
        if (stepHistoryIndex.current < stepHistory.current.length)
          stepHistory.current.splice(stepHistoryIndex.current);
        stepHistory.current.push({
          bgColor: bgColor,
          showGridBg: showGridBg,
          components: components,
        });
      } else if (stepHistoryCheck.current == 0) stepHistoryCheck.current = 1;
      saveCntRef.current = saveCntRef.current + 1;
      var saveCnt = saveCntRef.current; // if a new update coming, old update may ignore
      /*console.log(
        "stepHistory.current",
        stepHistory.current,
        "stepHistoryIndex.current",
        stepHistoryIndex.current
      );*/
      ts = new Date().getTime();
      await new Promise((resolve) => setTimeout(resolve, 500));
      if (saveCnt !== saveCntRef.current) {
        //console.log('bypassed1', saveCnt, saveCntRef.current)
        return;
      }
      const uri = await getImageDataUrl();
      if (saveCnt !== saveCntRef.current) {
        //console.log('bypassed2', saveCnt, saveCntRef.current)
        return;
      }
      //console.log("uri", uri);
      var imageDataFile = null;
      if (uri) {
        const file = dataURLtoFile(uri, moodboard_id);
        //console.log("file", file);
        new Compressor(file, {
          maxWidth: 1000,
          maxHeight: 1000,
          quality: 0.92,
          mimeType: "image/jpeg",
          success: async (result) => {
            if (saveCnt !== saveCntRef.current) {
              //console.log('bypassed3', saveCnt, saveCntRef.current)
              return;
            }
            imageDataFile = new File([result], result.name, { type: "image/jpeg" });
            saveMoodBoardImg(imageDataFile);
            console.log("Save moodboard image take", new Date().getTime() - ts, "ms");
          },
          error(err) {
            console.log(err.message);
            toast.error("Save moodboard Image failed! " + err.message);
          },
        });
      } else {
        saveMoodBoardImg(null);
      }
    } catch (err) {
      console.log(err);
      toast.error("Save moodboard failed!");
    }
  };

  //console.log('isDirty', isDirty)
  useEffect(() => {
    function handleResize() {
      setAreaWidth(window.innerWidth - 100);
      setAreaHeight(window.innerHeight - 110);
    }
    retrieveContentPermission();
    handleResize();
    window.addEventListener("resize", handleResize);
    const timer = setInterval(() => {
      if (isDirtyRef.current) {
        console.log("Safety trigger auto save");
        setIsDirty(false);
      }
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    //console.log("moodboard_id", moodboard_id);

    loadMoodBoard(true);
  }, [moodboard_id]);

  useEffect(() => {
    if (isDirty) {
      saveMoodBoard();
    }
  }, [isDirty]);

  useEffect(() => {
    var maxwidth = Math.max(...components.map((c) => c.x + c.width), 0);
    var maxheight = Math.max(
      ...components.map((c) => c.y + c.height + (c.caption?.length > 0 ? 60 : 0)),
      0
    );
    setSketchWidth(Math.max(areaWidth, (Math.ceil(maxwidth / 100) + 1) * 100));
    setSketchHeight(Math.max(areaHeight, (Math.ceil(maxheight / 100) + 1) * 100));
  }, [components, areaWidth, areaHeight]);

  useEffect(() => {
    setAnchorEl(null);
    setAnchorZoomEl(null);
  }, [selectedComponentId]);

  var selectedComponents = components.filter((c) => selectedComponentId.includes(c.id));
  var archivedComponents = components.filter((c) => c.archived);
  selectedComponentsRef.current = selectedComponents;
  var selectedComponent = selectedComponents.length === 1 ? selectedComponents[0] : null;
  var selectedComponentText = null;
  if (selectedComponent) {
    if (selectedComponent.type === "image") {
      selectedComponentText = selectedComponent.name?.replace(/\.[^/.]+$/, "");
      if (!selectedComponentText || selectedComponentText === "") selectedComponentText = "Image";
    } else if (selectedComponent.type === "color") selectedComponentText = selectedComponent.color;
    else if (selectedComponent.type === "text") selectedComponentText = "Text";
    else if (selectedComponent.type === "video") selectedComponentText = "Youtube";
    else if (selectedComponent.type === "music") selectedComponentText = "Spotify";
  }
  var bcomponents = JSON.parse(JSON.stringify(components));
  var bmaxX = Math.max(...bcomponents.map((c) => c.x + c.width), 0) + 100;
  var bmaxY =
    Math.max(...bcomponents.map((c) => c.y + c.height + (c.caption?.length > 0 ? 60 : 0)), 0) + 100;
  var bminX = 0; //Math.min(...bcomponents.map((c) => c.x), bmaxX);
  var bminY = 0; //Math.min(...bcomponents.map((c) => c.y), bmaxY);
  var bwidth = bmaxX - bminX;
  var bheight = bmaxY - bminY;
  bcomponents = bcomponents.map((c) => {
    return { ...c, x: c.x - bminX, y: c.y - bminY };
  });
  const collectionPermission = moodboardData?.collection?.id
    ? permissionMap?.[moodboardData?.collection?.id]
    : null;
  const canWrite =
    (account.account_type == "de" && !sharedView) ||
    (sharedView && checkPermission(moodboard_id, moodboardData?.collection?.id, permissionMap));

  const getImageDataUrl = async () => {
    if (bcomponents.filter((c) => c.x >= 0).length === 0) return null;
    var sketch = document.getElementById("exportmoodboard");
    //https://img.youtube.com/vi/LpNDrrly3GI/0.jpg
    //https://github.com/niklasvh/html2canvas/issues/2948
    //console.log('exportComponentAsPNG(imgRef)', bcomponents.length, exportComponentAsPNG(imgRef))
    const uri = sketch?.childNodes[0]?.childNodes[0]?.childNodes[0]?.toDataURL();
    return uri;
  };

  const handleExport = async () => {
    const uri = await getImageDataUrl();
    if (uri !== null) {
      //console.log('uri', uri)
      var link = document.createElement("a");
      link.download = name;
      link.href = uri;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const addComponent = (newObj, dirty = true) => {
    setComponents((prevState) => [...prevState, fitBlock(newObj)]);
    if (newObj.archived) setShowArchived(true);
    else setSelectedComponentId([newObj.id]);
    if (dirty) setIsDirty(true);
  };

  const updateComponent = async (component, pos = 2, dirty = true, moveposition = false) => {
    if (dirty) component = fitBlock(component);
    component.refreshIndex = ((component.refreshIndex ?? 0) + 1) % 1000;
    if (
      selectedComponents.length > 1 &&
      selectedComponentId.includes(component.id) &&
      moveposition
    ) {
      var oldcomponent = components.find((c) => c.id === component.id);
      var diffx = component.x - oldcomponent.x;
      var diffy = component.y - oldcomponent.y;
      var newObjs = components.map((c) => {
        if (c.lock !== 1 && selectedComponentId.includes(c.id)) {
          var newObj = { ...c, x: c.x + diffx, y: c.y + diffy };
          return dirty ? fitBlock(newObj) : newObj;
        }
        return c;
      });
      setComponents(newObjs);
      if (dirty) setIsDirty(true);
      return;
    }
    if (pos === 1) {
      // keep current position
      var newObjs = components.map((c) => {
        return c.id === component.id ? component : c;
      });
    } else {
      // 0 put in front, 2 put at the end
      var newObjs = components.filter((c) => c.id !== component.id);
      if (pos === 0) newObjs.unshift(component);
      else newObjs.push(component);
    }
    setComponents(newObjs);
    if (dirty) setIsDirty(true);
  };

  const addImgUrl = async (
    rid,
    url,
    filetype = null,
    filename = null,
    origComponent = null,
    dirty = true
  ) => {
    try {
      const { width, height } = await getImageDimensions(url);
      var width2 = Math.min(width, 300);
      var height2 = (width2 * height) / width;
      if (origComponent) {
        var updateObj = {
          ...origComponent,
          rawwidth: width,
          rawheight: height,
          name: filename,
          src: url,
          rotation: 0,
          crop: undefined,
        };
        updateComponent(updateObj, 1);
      } else {
        var newObj = {
          ...uploadImgPosition.current,
          id: rid,
          filetype: filetype,
          type: "image",
          rawwidth: width,
          rawheight: height,
          width: width2,
          height: height2,
          name: filename,
          src: url,
          ts: new Date(),
          archived: uploadImgPosition.current.x < 0,
        };
        addComponent(newObj, dirty);
      }
      if (uploadImgPosition.current.x >= 0) uploadImgPosition.current.x += width2 + 20;
    } catch (err) {
      console.log(err);
      toast.error("File can not be processed due to incompatible format!");
    }
  };

  const uploadImgFile = async (file, origComponent = null, dirty = true) => {
    setUploading(true);
    var rid = nanoid();
    var name = rid + "_" + file.name;
    var file2 = new File([file], name, { type: file.type });
    var imgPosition = uploadImgPosition.current;
    //console.log('uploadImgPosition.current1.6', uploadImgPosition.current)
    const url = await api.uploads.create([file2]).then(({ data }) => {
      const uploaded = data.uploads.map(({ url }) => url);
      return uploaded;
    });
    uploadImgPosition.current = imgPosition;
    //console.log('uploadImgPosition.current1.7', uploadImgPosition.current)
    //console.log('url', url, file2)
    if (url && url.length == 1) {
      await addImgUrl(rid, url[0], file.type, file.name, origComponent, dirty);
    }
    setUploading(false);
  };

  const addURL = async (url) => {
    if (url.startsWith("https://www.youtube.com/watch?v=") && url.length >= 43) {
      var youtube_id = url.substring(32, 43);
      const summary = await fetch(
        "https://www.youtube.com/oembed?url=http%3A//youtube.com/watch%3Fv%3D" +
          youtube_id +
          "&format=json"
      ).then((r) => r.json());
      //console.log('summary', summary)
      var newObj = {
        ...uploadImgPosition.current,
        id: nanoid(),
        type: "video",
        url: url,
        width: 298,
        height: 168,
        youtube_id: youtube_id,
        caption: summary.title,
        ts: new Date(),
        imgurl: summary.thumbnail_url,
        title: summary.title,
        archived: uploadImgPosition.current.x < 0,
      };
      addComponent(newObj);
      return;
    }
    //https://open.spotify.com/track/6zTbtySCRStJOv5xA4XvRE
    if (url.startsWith("https://open.spotify.com/track/") && url.length >= 53) {
      var spotify_id = url.substring(31, 53);
      const response = await api.uploads.downloadurl({
        url: "https://api.spotify.com/v1/tracks/" + spotify_id + "?market=us",
      });
      var summary = JSON.parse(atob(response.data.base64));
      //console.log('summary', summary)
      var newObj = {
        ...uploadImgPosition.current,
        id: nanoid(),
        type: "music",
        url: url,
        width: 298,
        height: 238,
        spotify_id: spotify_id,
        caption: summary?.name,
        imgurl: summary?.album?.images[0]?.url,
        ts: new Date(),
        archived: uploadImgPosition.current.x < 0,
      };
      addComponent(newObj);
      return;
    }
    if (url.startsWith("data:")) {
      const file = dataURLtoFile(url, "");
      uploadImgFile(file);
    }
    const response = await api.uploads.downloadurl({ url: url });
    if (response.data.contenttype.startsWith("image/")) {
      var data = "data:" + response.data.contenttype + ";base64," + response.data.base64;
      //console.log('response', response)
      var name = url.substring(url.lastIndexOf("/") + 1);
      if (name.indexOf("?") > 0) name = name.substring(0, name.indexOf("?"));
      const file = dataURLtoFile(data, name);
      uploadImgFile(file);
    } else {
      toast.error(
        "You are trying to upload " +
          url +
          " which is not a correct image, youtube video, or spotify music url."
      );
    }
  };

  const dropFile = async (e) => {
    e.preventDefault();
    stageRef.current.setPointersPositions(e);
    uploadImgPosition.current = stageRef.current.getPointerPosition();
    //console.log('dropFile', dragType, e, uploadImgPosition.current)
    if (dragType == "text") {
      setSelectedComponentId([]);
      setShowTextDialog(true);
    } else if (dragType == "color") {
      setSelectedComponentId([]);
      setShowColorDialog(true);
    } else if (dragType == "image") {
      addImageRef.current.click();
    } else if (dragType == "link") {
      setSelectedComponentId([]);
      setShowLinkDialog(true);
    } else if (components.find((c) => c.id === dragType)) {
      var mc = components.find((c) => c.id === dragType);
      //console.log('mc', mc)
      updateComponent({
        ...mc,
        archived: false,
        x: uploadImgPosition.current.x,
        y: uploadImgPosition.current.y,
      });
      setShowArchived(archivedComponents.length > 1);
    } else {
      if (e.dataTransfer?.files.length > 0) {
        for (var file of e.dataTransfer?.files) {
          //console.log('file', file)
          await uploadImgFile(file, null, false);
        }
        setIsDirty(true);
      }
      //for (var item of e.dataTransfer?.items) console.log('item', item)
      var url = e.dataTransfer.getData("text/uri-list");
      //console.log('url', url)
      if (url === undefined || url === "" || !url.startsWith("http")) {
        url = "";
        var htmlstr = e.dataTransfer.getData("text/html");
        //console.log('htmlstr', htmlstr)
        if (htmlstr !== undefined && htmlstr !== "") {
          var el = document.createElement("html");
          el.innerHTML = htmlstr;
          var imgnodes = el.getElementsByTagName("img");
          if (imgnodes.length === 1) {
            url = imgnodes[0].src;
          }
        }
      }
      if (url !== undefined && url !== "") {
        addURL(url);
      }
    }
    setDragType(null);
  };

  const deleteFunc = (component, e) => {
    e.evt.stopPropagation();
    e.evt.preventDefault();
    setPromptConfig({
      heading: "Delete Confirmation",
      text: "Are you sure you want to delete this item?",
      handleOk: () => {
        setComponents((current) => current.filter((c) => c.id !== component.id));
        setIsDirty(true);
      },
    });
  };

  const unLockfunc = (component, e) => {
    e.evt.stopPropagation();
    e.evt.preventDefault();
    updateComponent({ ...component, lock: 0 }, 1);
  };

  const ShowLinkDialog = ({}) => {
    const [link, setLink] = useState("");

    return (
      <Dialog
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "550px",
              height: "250px",
            },
          },
        }}
        open={showLinkDialog}
        onClose={() => setShowLinkDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Add Link
          <IconButton
            aria-label="close"
            onClick={() => {
              setShowLinkDialog(false);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <SuiBox sx={{ m: 1 }} display="flex" justifyContent="space-between" alignItems="center">
            <SuiTypography variant="caption">Link</SuiTypography>
            <SuiBox sx={{ width: "450px" }}>
              <SuiInput
                size="small"
                value={link}
                onChange={(e) => {
                  setLink(e.target.value);
                }}
              />
            </SuiBox>
          </SuiBox>
        </DialogContent>
        <DialogActions>
          <SuiButton
            onClick={async () => {
              setShowLinkDialog(false);
              addURL(link);
            }}
            color={"dark"}
            variant="gradient"
          >
            Add
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  };

  const ShowTextDialog = ({}) => {
    const [content, setContent] = useState(selectedComponent ? selectedComponent.content : "");
    var useDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;

    const handleEditorChange = (content, editor) => {
      setContent(content);
    };

    return (
      <Dialog
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "820px",
              height: "700px",
              maxWidth: "820px",
            },
          },
        }}
        open={showTextDialog}
        onClose={() => setShowTextDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Edit Text
          <IconButton
            aria-label="close"
            onClick={() => {
              setShowTextDialog(false);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Editor
            apiKey="gyml00g4lb1muvv9cai1t3hr8raf55cz3w6wdblguzvtam9w"
            initialValue={selectedComponent ? selectedComponent.content : ""}
            onEditorChange={handleEditorChange}
            init={{
              selector: "textarea",
              plugins: "lists quickbars",
              menubar: false,
              toolbar:
                "undo redo fontfamily fontsize bold italic forecolor backcolor removeformat alignleft aligncenter alignright alignjustify outdent indent ",
              toolbar_mode: "wrap",
              toolbar_sticky: true,
              statusbar: false,
              height: 500,
              contextmenu: false,
              quickbars_selection_toolbar: "bold italic",
              quickbars_insert_toolbar: false,
              noneditable_noneditable_class: "mceNonEditable",
              skin: useDarkMode ? "oxide-dark" : "oxide",
              content_css: useDarkMode ? "dark" : "default",
              fontsize_formats: "8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt",
              // content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:18pt }'
            }}
          />
        </DialogContent>
        <DialogActions>
          <SuiButton
            onClick={async () => {
              if (selectedComponent) {
                updateComponent({ ...selectedComponent, content: content });
              } else {
                var newObj = {
                  ...uploadImgPosition.current,
                  id: nanoid(),
                  type: "text",
                  width: 298,
                  height: 198,
                  content: content,
                  ts: new Date(),
                  archived: uploadImgPosition.current.x < 0,
                };
                addComponent(newObj);
              }
              setShowTextDialog(false);
            }}
            color={"dark"}
            variant="gradient"
          >
            Save
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  };

  const ShowCropImageDialog = ({}) => {
    if (!selectedComponent) return <></>;
    const defaultCrop = {
      unit: "%", // Can be 'px' or '%'
      x: 5,
      y: 5,
      width: 90,
      height: 90,
    };
    const [crop, setCrop] = useState(selectedComponent.crop ?? defaultCrop);
    var ratio = 500 / Math.max(selectedComponent.rawwidth, selectedComponent.rawheight);
    var width = selectedComponent.rawwidth * ratio;
    var height = selectedComponent.rawheight * ratio;
    //console.log('crop', crop, 'width', width, 'height', height)
    return (
      <Dialog
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "540px",
              height: "750px",
            },
          },
        }}
        open={showCropImageDialog}
        onClose={() => setShowCropImageDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Crop Image
          <IconButton
            aria-label="close"
            onClick={() => {
              setShowCropImageDialog(false);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ overflow: "hidden" }}>
          <SuiBox display="flex" alignItems="center" sx={{ mb: 1 }}>
            <SuiTypography>Use mouse to select the region to crop image.</SuiTypography>
          </SuiBox>
          <SuiBox
            sx={{ width: 500, height: 500 }}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <ReactCrop
              crop={crop}
              onChange={(_, crop) => {
                setCrop(crop);
              }}
              style={{ width: width, height: height }}
            >
              <img src={selectedComponent.src} width={width} height={height} />
            </ReactCrop>
          </SuiBox>
        </DialogContent>
        <DialogActions>
          <SuiButton
            onClick={() => {
              setCrop({ unit: "%", x: 0, y: 0, width: 0, height: 0 });
            }}
            color={"dark"}
            variant="gradient"
          >
            Clear
          </SuiButton>
          <SuiButton
            onClick={() => {
              var newobj = {
                ...selectedComponent,
                crop: crop.width > 0 && crop.height > 0 ? crop : undefined,
              };
              updateComponent(newobj, 1);
              setShowCropImageDialog(false);
            }}
            color={"dark"}
            variant="gradient"
          >
            Save
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  };

  const ShowCaptionDialog = ({}) => {
    if (!selectedComponent) return <></>;
    const [caption, setCaption] = useState(selectedComponent.caption ?? "");
    return (
      <Dialog
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "540px",
              height: "450px",
            },
          },
        }}
        open={showCaptionDialog}
        onClose={() => setShowCaptionDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Add Caption
          <IconButton
            aria-label="close"
            onClick={() => {
              setShowCaptionDialog(false);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ overflow: "hidden" }}>
          <SuiBox sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
            <SuiBox>
              <SuiTypography variant="caption">Caption</SuiTypography>
            </SuiBox>
            <SuiBox sx={{ width: 400 }}>
              <SuiInput
                size="small"
                defaultValue={caption}
                onChange={(e) => {
                  setCaption(e.target.value);
                }}
              />
            </SuiBox>
          </SuiBox>
        </DialogContent>
        <DialogActions>
          <SuiButton
            onClick={() => {
              var newobj = {
                ...selectedComponent,
                caption: caption.length > 0 ? caption : undefined,
              };
              updateComponent(newobj, 1);
              setShowCaptionDialog(false);
            }}
            color={"dark"}
            variant="gradient"
          >
            Save
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  };

  const ShowComments = ({}) => {
    const notifyFunc = (message) => {};

    return (
      <Popper
        id={anchorEl ? "comments-popover" : undefined}
        style={{ zIndex: 100000 }}
        open={anchorEl !== null}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        placement="right"
      >
        <Card sx={{ ml: "10px" }}>
          <SuiBox sx={{ mx: 1, mt: 1.5, width: "650px", height: "650px", overflow1: "auto" }}>
            <Comments
              subjectid={moodboard_id + "_" + (selectedComponent ? selectedComponent.id : "")}
              notifyFunc={notifyFunc}
              closeFunc={() => setAnchorEl(null)}
            />
          </SuiBox>
        </Card>
      </Popper>
    );
  };

  const ComponentMenu = ({ component }) => {
    const [menuComponent, setMenuComponent] = useState(component);
    useEffect(() => {
      setMenuComponent(component);
    }, [component]);

    return (
      <>
        {menuComponent.type == "text" && (
          <Grid item lg={6} md={6} sm={12} xs={12} className="moodboard-function-button-inactive">
            <SuiBox
              sx={{ cursor: "pointer", mt: menuTop }}
              onClick={() => {
                setShowTextDialog(true);
              }}
            >
              <SuiBox className="flex justify-center">
                <EditIcon fontSize="small" />
              </SuiBox>
              <SuiBox className="flex justify-center">
                <SuiTypography variant={menuFont}>Edit Text</SuiTypography>
              </SuiBox>
            </SuiBox>
          </Grid>
        )}
        {menuComponent.type == "text" && (
          <Grid item lg={6} md={6} sm={12} xs={12} className="moodboard-function-button-inactive">
            <SuiBox sx={{ mt: menuTop }}>
              <SuiBox className="flex justify-center">
                <input
                  type="color"
                  value={
                    menuComponent.bgcolor === "" ? bgcolor : menuComponent.bgcolor ?? "#FFFFFF"
                  }
                  onChange={(e) => {
                    updateComponent({ ...menuComponent, bgcolor: e.target.value.toUpperCase() }, 1);
                  }}
                />
              </SuiBox>
              <SuiBox className="flex justify-center">
                <SuiTypography variant={menuFont}>Card Color</SuiTypography>
              </SuiBox>
            </SuiBox>
          </Grid>
        )}
        {menuComponent.type == "text" && menuComponent.bgcolor !== "" && (
          <Grid item lg={6} md={6} sm={12} xs={12} className="moodboard-function-button-inactive">
            <Tooltip title="Clear color to make card transparent" placement="right">
              <SuiBox
                sx={{ cursor: "pointer", mt: menuTop }}
                onClick={() => {
                  updateComponent({ ...menuComponent, bgcolor: "" }, 1);
                }}
              >
                <SuiBox className="flex justify-center">
                  <OpacityIcon fontSize="small" />
                </SuiBox>
                <SuiBox className="flex justify-center">
                  <SuiTypography sx={{ textAlign: "center" }} variant={menuFont}>
                    Card Transparent
                  </SuiTypography>
                </SuiBox>
              </SuiBox>
            </Tooltip>
          </Grid>
        )}
        {menuComponent.type == "color" && (
          <Grid item lg={6} md={6} sm={12} xs={12} className="moodboard-function-button-inactive">
            <SuiBox sx={{ mt: menuTop }}>
              <SuiBox className="flex justify-center">
                <input
                  type="color"
                  value={menuComponent.color}
                  onChange={(e) => {
                    updateComponent({ ...menuComponent, color: e.target.value.toUpperCase() }, 1);
                  }}
                />
              </SuiBox>
              <SuiBox className="flex justify-center">
                <SuiTypography variant={menuFont}>Color</SuiTypography>
              </SuiBox>
            </SuiBox>
          </Grid>
        )}
        {menuComponent.type == "image" && (
          <Grid item lg={6} md={6} sm={12} xs={12} className="moodboard-function-button-inactive">
            <SuiBox className="flex justify-center" sx={{ cursor: "pointer", mt: menuTop }}>
              <Upload
                accept="image/*"
                showUploadList={false}
                customRequest={async ({ file }) => await uploadImgFile(file, menuComponent)}
              >
                <SuiBox>
                  <SuiBox className="flex justify-center">
                    <UploadFileIcon fontSize="small" />
                  </SuiBox>
                  <SuiBox className="flex justify-center">
                    <SuiTypography variant={menuFont}>Replace</SuiTypography>
                  </SuiBox>
                </SuiBox>
              </Upload>
            </SuiBox>
          </Grid>
        )}
        {menuComponent.type == "image" && (
          <Grid item lg={6} md={6} sm={12} xs={12} className="moodboard-function-button-inactive">
            <SuiBox
              sx={{ cursor: "pointer", mt: menuTop }}
              onClick={() => {
                setShowCropImageDialog(true);
              }}
            >
              <SuiBox className="flex justify-center">
                <CropIcon fontSize="small" />
              </SuiBox>
              <SuiBox className="flex justify-center">
                <SuiTypography variant={menuFont}>Crop</SuiTypography>
              </SuiBox>
            </SuiBox>
          </Grid>
        )}
        {(menuComponent.type == "image" || menuComponent.type == "text") && (
          <Grid item lg={6} md={6} sm={12} xs={12} className="moodboard-function-button-inactive">
            <SuiBox
              sx={{ cursor: "pointer", mt: menuTop }}
              onClick={() => {
                var newobj = {
                  ...menuComponent,
                  rotation: menuComponent.rotation == 3 ? 0 : (menuComponent.rotation ?? 0) + 1,
                  width: menuComponent.height,
                  height: menuComponent.width,
                };
                updateComponent(newobj, 1);
              }}
            >
              <SuiBox className="flex justify-center">
                <Rotate90DegreesCwIcon fontSize="small" />
              </SuiBox>
              <SuiBox className="flex justify-center">
                <SuiTypography variant={menuFont}>Rotate</SuiTypography>
              </SuiBox>
            </SuiBox>
          </Grid>
        )}
        {menuComponent.type == "image" && (
          <Grid item lg={6} md={6} sm={12} xs={12} className="moodboard-function-button-inactive">
            <SuiBox
              sx={{ cursor: "pointer", mt: menuTop }}
              onClick={() => {
                setShowCaptionDialog(true);
              }}
            >
              <SuiBox className="flex justify-center">
                <SubtitlesIcon fontSize="small" />
              </SuiBox>
              <SuiBox className="flex justify-center">
                <SuiTypography variant={menuFont}>Caption</SuiTypography>
              </SuiBox>
            </SuiBox>
          </Grid>
        )}
        {menuComponent.caption && menuComponent.caption.length > 0 && (
          <Grid item lg={6} md={6} sm={12} xs={12} className="moodboard-function-button-inactive">
            <SuiBox sx={{ mt: menuTop }}>
              <SuiBox className="flex justify-center">
                <input
                  type="color"
                  value={
                    menuComponent.bgcolor === "" ? bgcolor : menuComponent.bgcolor ?? "#FFFFFF"
                  }
                  onChange={(e) => {
                    updateComponent({ ...menuComponent, bgcolor: e.target.value.toUpperCase() }, 1);
                  }}
                />
              </SuiBox>
              <SuiBox className="flex justify-center">
                <SuiTypography variant={menuFont}>Caption Color</SuiTypography>
              </SuiBox>
            </SuiBox>
          </Grid>
        )}
        {menuComponent.caption &&
          menuComponent.caption.length > 0 &&
          menuComponent.bgcolor !== "" && (
            <Grid item lg={6} md={6} sm={12} xs={12} className="moodboard-function-button-inactive">
              <Tooltip title="Clear color to make caption transparent" placement="right">
                <SuiBox
                  sx={{ cursor: "pointer", mt: menuTop }}
                  onClick={() => {
                    updateComponent({ ...menuComponent, bgcolor: "" }, 1);
                  }}
                >
                  <SuiBox className="flex justify-center">
                    <OpacityIcon fontSize="small" />
                  </SuiBox>
                  <SuiBox className="flex justify-center">
                    <SuiTypography sx={{ textAlign: "center" }} variant={menuFont}>
                      Make Caption Transparent
                    </SuiTypography>
                  </SuiBox>
                </SuiBox>
              </Tooltip>
            </Grid>
          )}
      </>
    );
  };

  const ShowZoom = ({}) => {
    return (
      <Popper
        id={anchorZoomEl ? "zoom-popover" : undefined}
        style={{ zIndex: 100000 }}
        open={anchorZoomEl !== null}
        anchorEl={anchorZoomEl}
        onClose={() => setAnchorZoomEl(null)}
        placement="right"
      >
        <Card sx={{ ml: "10px" }}>
          <SuiBox sx={{ mx: 2, mt: 1.5, width: "400px", height: "120px" }}>
            <SuiBox display="flex" justifyContent="space-between" alignItems="center">
              <SuiTypography variant="h6">Zoom</SuiTypography>
              <IconButton
                aria-label="close"
                onClick={() => {
                  setAnchorZoomEl(null);
                }}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </SuiBox>
            <SuiTypography variant="caption">
              Tip: hold {isMac ? "⌘" : "⊞"} and use mouse wheel to zoom
            </SuiTypography>
            <SuiBox display="flex" justifyContent="space-between" alignItems="center">
              <SuiTypography variant="caption">{Math.floor(sketchScale * 100)}%</SuiTypography>
              <SuiBox display="flex" alignItems="center">
                <SuiButton
                  size="small"
                  variant=""
                  sx={{ p: 0, m: 0, fontSize: 30, width: 20, height: 30 }}
                  disabled={sketchScale <= 0.25}
                  onClick={() =>
                    setSketchScale(Math.max(0.25, Math.ceil(sketchScale / 0.25 - 1) * 0.25))
                  }
                >
                  -
                </SuiButton>
                <SuiButton
                  size="small"
                  variant=""
                  sx={{ p: 0, m: 0, fontSize: 30, width: 20, height: 30 }}
                  disabled={sketchScale >= 3}
                  onClick={() =>
                    setSketchScale(Math.min(3, Math.floor(sketchScale / 0.25 + 1) * 0.25))
                  }
                >
                  +
                </SuiButton>
                <SuiButton
                  size="small"
                  variant=""
                  onClick={() => {
                    setSketchScale(1);
                    setAnchorZoomEl(null);
                  }}
                >
                  Reset
                </SuiButton>
              </SuiBox>
            </SuiBox>
          </SuiBox>
        </Card>
      </Popper>
    );
  };

  const handleChangeMoodboardName = async () => {
    let value = moodboardNameInputRef?.current?.value || "";
    value = value.trim();
    if (value == moodboardData.name || !value) {
      setEditNameVisible(false);
      return;
    }
    try {
      if (!moodboard_id) {
        let payload = {
          name: value,
        };
        const newMoodboard = await api.moodboard.create(payload);
        moodboard_id = newMoodboard?.data?.id;
        window.history.replaceState(
          "",
          "Moodboard",
          `${window.location.pathname}?id=${moodboard_id}`
        );
      } else {
        await api.moodboard.update({ id: moodboard_id, name: value });
      }
      loadMoodBoard();

      toast.success("Update moodboard name successfully!");
    } catch (err) {
      console.log(err);
      toast.failed("Update moodboard name failed!");
    }
    setEditNameVisible(false);
  };

  const handleShowEditMoodboardName = () => {
    setEditNameVisible(true);
    setInputWidth(moodboardData?.name?.length);
  };

  const handleRangeSelection = (evt) => {
    var offsetX = evt.offsetX / sketchScale;
    var offsetY = evt.offsetY / sketchScale;
    var range = {
      ...rangeSelection,
      sx: Math.min(rangeSelection.x, offsetX),
      sy: Math.min(rangeSelection.y, offsetY),
      ex: Math.max(rangeSelection.x, offsetX),
      ey: Math.max(rangeSelection.y, offsetY),
    };
    var out = components.filter((c) => {
      var ex = c.x + c.width;
      var ey = c.y + c.height + (c.caption ? 60 : 0);
      return !(ex <= range.sx || c.x >= range.ex || ey <= range.sy || c.y >= range.ey);
    });
    var newids = out.map((c) => c.id);
    if (!deepEqual(newids, selectedComponentId)) setSelectedComponentId(newids);
    return range;
  };

  // #region Math functions
  const unDo = () => {
    if (stepHistoryIndex.current <= 0) return;
    stepHistoryIndex.current = stepHistoryIndex.current - 1;
    stepHistoryCheck.current = 0;
    setBgColor(stepHistory.current[stepHistoryIndex.current].bgColor);
    setShowGridBg(stepHistory.current[stepHistoryIndex.current].showGridBg);
    setComponents(stepHistory.current[stepHistoryIndex.current].components);
    setIsDirty(true);
  };

  const reDo = () => {
    if (stepHistoryIndex.current >= stepHistory.current.length - 1) return;
    stepHistoryIndex.current = stepHistoryIndex.current + 1;
    stepHistoryCheck.current = 0;
    setBgColor(stepHistory.current[stepHistoryIndex.current].bgColor);
    setShowGridBg(stepHistory.current[stepHistoryIndex.current].showGridBg);
    setComponents(stepHistory.current[stepHistoryIndex.current].components);
    setIsDirty(true);
  };

  async function actionCut() {
    if (selectedComponentsRef.current.length > 0) {
      await navigator.clipboard.writeText(JSON.stringify(selectedComponentsRef.current));
      setComponents((current) =>
        current.filter((c) => !selectedComponentsRef.current.find((sc) => sc.id == c.id))
      );
      setIsDirty(true);
      toast.success("Cut " + selectedComponentsRef.current.length + " components.");
    }
  }

  async function actionCopy() {
    if (selectedComponentsRef.current.length > 0) {
      await navigator.clipboard.writeText(JSON.stringify(selectedComponentsRef.current));
      toast.success("Copied " + selectedComponentsRef.current.length + " components.");
    }
  }

  function actionDuplicate() {
    if (selectedComponentsRef.current.length > 0) {
      var newObjs = [];
      var newSelectedComponentId = [];
      for (var sc of selectedComponentsRef.current) {
        var newobj = {
          ...sc,
          id: nanoid(),
          x: sc.x + 20,
          y: sc.y + 20,
        };
        newSelectedComponentId.push(newobj.id);
        newObjs.push(newobj);
      }
      setComponents((oldArray) => [...oldArray, ...newObjs]);
      setSelectedComponentId(newSelectedComponentId);
      setIsDirty(true);
    }
  }

  async function actionPaste() {
    var position = stageRef.current.getPointerPosition();
    console.log("before read");
    const clipboardItems = await navigator.clipboard.read();
    console.log("paste", clipboardItems);
    for (const clipboardItem of clipboardItems) {
      const imageType = clipboardItem.types.find((type) => type.startsWith("image/"));
      if (imageType) {
        const blob = await clipboardItem.getType(imageType);
        uploadImgPosition.current = position;
        //console.log('paste', blob,)
        await uploadImgFile(blob);
        uploadImgPosition.current = { x: 0, y: 0 };
        continue;
      }
      const textType = clipboardItem.types.find((type) => type.startsWith("text/plain"));
      if (textType) {
        const blob = await clipboardItem.getType(textType);
        const text = await blob.text();
        console.log("paste", text);
        if (text.startsWith("http")) {
          uploadImgPosition.current = position;
          await addURL(text);
          uploadImgPosition.current = { x: 0, y: 0 };
        }
        if (text.startsWith("[")) {
          var copiedComponents = JSON.parse(text);
          var minX = Math.min(...copiedComponents.map((c) => c.x));
          var minY = Math.min(...copiedComponents.map((c) => c.y));
          var newObjs = [];
          var newSelectedComponentId = [];
          for (var sc of copiedComponents) {
            var newobj = {
              ...sc,
              id: nanoid(),
              x: sc.x - minX + position.x,
              y: sc.y - minY + position.y,
            };
            newSelectedComponentId.push(newobj.id);
            newObjs.push(newobj);
          }
          setComponents((oldArray) => [...oldArray, ...newObjs]);
          setSelectedComponentId(newSelectedComponentId);
          setIsDirty(true);
          toast.success("Pasted " + copiedComponents.length + " components.");
        }
        continue;
      }
    }
  }

  function actionDelete() {
    if (selectedComponentsRef.current.length > 0) {
      setPromptConfig({
        heading: "Delete Confirmation",
        text:
          "Are you sure you want to delete selected " +
          selectedComponentsRef.current.length +
          " items?",
        handleOk: () => {
          setComponents((current) =>
            current.filter((c) => !selectedComponentsRef.current.find((sc) => sc.id == c.id))
          );
          setIsDirty(true);
        },
      });
    }
  }

  async function keyPress(e) {
    var evtobj = window.event ? window.event : e;
    var code = evtobj.keyCode || evtobj.which;
    //console.log('evtobj', evtobj, code, selectedComponentsRef.current)
    if ((code == 90 || code == 122) && (evtobj.metaKey || evtobj.ctrlKey)) {
      //console.log(evtobj.shiftKey ? "Redo" : "Undo");
      if (evtobj.shiftKey) reDo();
      else unDo();
      evtobj.stopPropagation();
      evtobj.preventDefault();
    }
    if ((code == 89 || code == 121) && evtobj.ctrlKey) {
      reDo();
      evtobj.stopPropagation();
      evtobj.preventDefault();
    }
    if ((code == 65 || code == 97) && (evtobj.metaKey || evtobj.ctrlKey)) {
      //select all
      e.cancelBubble = true;
      setSelectedComponentId(componentsRef.current.filter((c) => !c.archived).map((c) => c.id));
      evtobj.stopPropagation();
      evtobj.preventDefault();
    }
    if (code == 127 || evtobj.key == "Delete") {
      actionDelete();
      evtobj.stopPropagation();
      evtobj.preventDefault();
    }
    if ((code == 88 || code == 120) && (evtobj.metaKey || evtobj.ctrlKey)) {
      await actionCut();
      evtobj.stopPropagation();
      evtobj.preventDefault();
    }
    if ((code == 67 || code == 99) && (evtobj.metaKey || evtobj.ctrlKey)) {
      await actionCopy();
      evtobj.stopPropagation();
      evtobj.preventDefault();
    }
    if ((code == 68 || code == 100) && (evtobj.metaKey || evtobj.ctrlKey)) {
      actionDuplicate();
      evtobj.stopPropagation();
      evtobj.preventDefault();
    }
    if ((code == 86 || code == 97) && (evtobj.metaKey || evtobj.ctrlKey)) {
      await actionPaste();
      evtobj.stopPropagation();
      evtobj.preventDefault();
    }
    if (
      selectedComponentsRef.current.length > 0 &&
      (evtobj.key == "ArrowUp" ||
        evtobj.key == "ArrowDown" ||
        evtobj.key == "ArrowLeft" ||
        evtobj.key == "ArrowRight")
    ) {
      var newComponents = componentsRef.current.map((c) => {
        if (c.lock !== 1 && selectedComponentsRef.current.find((sc) => sc.id == c.id)) {
          var newx = c.x;
          var newy = c.y;
          if (evtobj.key == "ArrowUp") newy = Math.max(0, newy - blockPixels);
          else if (evtobj.key == "ArrowDown") newy = newy + blockPixels;
          else if (evtobj.key == "ArrowLeft") newx = Math.max(0, newx - blockPixels);
          else if (evtobj.key == "ArrowRight") newx = newx + blockPixels;
          return { ...c, x: newx, y: newy };
        }
        return c;
      });
      setComponents(newComponents);
      setIsDirty(true);
      evtobj.stopPropagation();
      evtobj.preventDefault();
    }
  }
  // #endregion

  const ComponentContextMenu = ({}) => {
    const fontSize = "14px";
    var py = "2px";
    var x = contextMenuComponent.x;
    var y = contextMenuComponent.y;
    var selectedMode = selectedComponents.length > 0;
    if (x > areaWidth - 250 && x > 200) x -= 200;
    if (y > areaHeight - 250 && y > 250) y -= 250;

    return (
      <Html groupProps={{ x: x, y: y }} divProps={{ style: { opacity: 1 } }}>
        <Paper sx={{ width: 200, maxWidth: "100%" }}>
          {selectedMode && (
            <MenuList>
              <MenuItem
                sx={{ py: py }}
                onContextMenu={(e) => e.preventDefault()}
                onClick={() => {
                  actionCut();
                  setContextMenuComponent(null);
                }}
              >
                <ListItemIcon>
                  <ContentCutIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>Cut</ListItemText>
                <Typography variant="caption" color="text.secondary">
                  {isMac ? "⌘X" : "Ctrl+X"}
                </Typography>
              </MenuItem>
              <MenuItem
                sx={{ py: py }}
                onContextMenu={(e) => e.preventDefault()}
                onClick={() => {
                  actionCopy();
                  setContextMenuComponent(null);
                }}
              >
                <ListItemIcon>
                  <ContentCopyIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>Copy</ListItemText>
                <Typography variant="caption" color="text.secondary">
                  {isMac ? "⌘C" : "Ctrl+C"}
                </Typography>
              </MenuItem>
              <MenuItem
                sx={{ py: py }}
                onContextMenu={(e) => e.preventDefault()}
                onClick={() => {
                  actionDuplicate();
                  setContextMenuComponent(null);
                }}
              >
                <ListItemIcon>
                  <TbCopy fontSize="26px" />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>
                  Duplicate
                </ListItemText>
                <Typography variant="caption" color="text.secondary">
                  {isMac ? "⌘D" : "Ctrl+D"}
                </Typography>
              </MenuItem>
              <MenuItem
                sx={{ py: py }}
                onContextMenu={(e) => e.preventDefault()}
                onClick={() => {
                  actionDelete();
                  setContextMenuComponent(null);
                }}
              >
                <ListItemIcon>
                  <DeleteIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>Delete</ListItemText>
                <Typography variant="caption" color="text.secondary">
                  Delete
                </Typography>
              </MenuItem>
              <MenuItem
                sx={{ py: py }}
                onContextMenu={(e) => e.preventDefault()}
                onClick={() => {
                  var newObjs = components.map((c) => {
                    if (selectedComponentId.includes(c.id))
                      return { ...c, archived: true, x: -10000, y: -10000, lock: 0 };
                    return c;
                  });
                  setComponents(newObjs);
                  setIsDirty(true);
                  setContextMenuComponent(null);
                  setSelectedComponentId([]);
                  setShowArchived(true);
                }}
              >
                <ListItemIcon>
                  <ArchiveIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>
                  Move to My Inspo
                </ListItemText>
              </MenuItem>
              <Divider />
              <MenuItem
                sx={{ py: py }}
                onContextMenu={(e) => e.preventDefault()}
                onClick={() => {
                  var newObjs = [...components];
                  for (var sc of selectedComponents) {
                    newObjs = newObjs.filter((c) => c.id !== sc.id);
                    newObjs.push(sc);
                  }
                  setComponents(newObjs);
                  setIsDirty(true);
                  setContextMenuComponent(null);
                }}
              >
                <ListItemIcon>
                  <LayersIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>
                  To Front
                </ListItemText>
              </MenuItem>
              <MenuItem
                sx={{ py: py }}
                onContextMenu={(e) => e.preventDefault()}
                onClick={() => {
                  var newObjs = [...components];
                  for (var sc of selectedComponents) {
                    newObjs = newObjs.filter((c) => c.id !== sc.id);
                    newObjs.unshift(sc);
                  }
                  setComponents(newObjs);
                  setIsDirty(true);
                  setContextMenuComponent(null);
                }}
              >
                <ListItemIcon>
                  <FlipToBackIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>To Back</ListItemText>
              </MenuItem>
              {selectedComponents.find((c) => (c.lock ?? 0) === 0) && (
                <MenuItem
                  sx={{ py: py }}
                  onContextMenu={(e) => e.preventDefault()}
                  onClick={() => {
                    var newObjs = components.map((c) => {
                      if (selectedComponentId.includes(c.id)) return { ...c, lock: 1 };
                      return c;
                    });
                    setComponents(newObjs);
                    setIsDirty(true);
                    setContextMenuComponent(null);
                  }}
                >
                  <ListItemIcon>
                    <LockIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>Lock</ListItemText>
                </MenuItem>
              )}
              {selectedComponents.find((c) => c.lock === 1) && (
                <MenuItem
                  sx={{ py: py }}
                  onContextMenu={(e) => e.preventDefault()}
                  onClick={() => {
                    var newObjs = components.map((c) => {
                      if (selectedComponentId.includes(c.id)) return { ...c, lock: 0 };
                      return c;
                    });
                    setComponents(newObjs);
                    setIsDirty(true);
                    setContextMenuComponent(null);
                  }}
                >
                  <ListItemIcon>
                    <LockOpenIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>
                    Unlock
                  </ListItemText>
                </MenuItem>
              )}
            </MenuList>
          )}
          {!selectedMode && (
            <MenuList>
              <MenuItem
                sx={{ py: py }}
                onContextMenu={(e) => e.preventDefault()}
                onClick={() => {
                  actionPaste();
                  setContextMenuComponent(null);
                }}
              >
                <ListItemIcon>
                  <ContentPasteIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>Paste</ListItemText>
                <Typography variant="caption" color="text.secondary">
                  {isMac ? "⌘V" : "Ctrl+V"}
                </Typography>
              </MenuItem>
              <MenuItem
                sx={{ py: py }}
                onContextMenu={(e) => e.preventDefault()}
                onClick={() => {
                  setSelectedComponentId(components.filter((c) => !c.archived).map((c) => c.id));
                  setContextMenuComponent(null);
                }}
              >
                <ListItemIcon>
                  <SelectAllIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>
                  Select All
                </ListItemText>
                <Typography variant="caption" color="text.secondary">
                  {isMac ? "⌘A" : "Ctrl+A"}
                </Typography>
              </MenuItem>
              {stepHistoryIndex.current > 0 && (
                <MenuItem
                  sx={{ py: py }}
                  onContextMenu={(e) => e.preventDefault()}
                  onClick={() => {
                    unDo();
                    setContextMenuComponent(null);
                  }}
                >
                  <ListItemIcon>
                    <UndoIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>Undo</ListItemText>
                  <Typography variant="caption" color="text.secondary">
                    {isMac ? "⌘Z" : "Ctrl+Z"}
                  </Typography>
                </MenuItem>
              )}
              {stepHistoryIndex.current < stepHistory.current.length - 1 && (
                <MenuItem
                  sx={{ py: py }}
                  onContextMenu={(e) => e.preventDefault()}
                  onClick={() => {
                    reDo();
                    setContextMenuComponent(null);
                  }}
                >
                  <ListItemIcon>
                    <RedoIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>Redo</ListItemText>
                  <Typography variant="caption" color="text.secondary">
                    {isMac ? "Shift+⌘Z" : "Ctrl+Shift+Z"}
                  </Typography>
                </MenuItem>
              )}
              <Divider />
              <MenuItem
                sx={{ py: py, lineHeight: 0, width: "100%" }}
                onContextMenu={(e) => e.preventDefault()}
              >
                <Upload
                  accept="image/*"
                  fileList={[]}
                  multiple
                  showUploadList={false}
                  customRequest={async (e1) => {}}
                  beforeUpload={(e3) => {}}
                  onChange={async (e2) => {
                    //console.log('e2', e2)
                    if (e2.file.uid === e2.fileList[e2.fileList.length - 1].uid) {
                      setContextMenuComponent(null);
                      uploadImgPosition.current = {
                        x: contextMenuComponent.x,
                        y: contextMenuComponent.y,
                      };
                      for (var file of e2.fileList)
                        await uploadImgFile(file.originFileObj, null, false);
                      setIsDirty(true);
                    }
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", width: "180px" }}>
                    <ListItemIcon>
                      <ImageIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>
                      Add Image
                    </ListItemText>
                  </div>
                </Upload>
              </MenuItem>
              <MenuItem
                sx={{ py: py }}
                onContextMenu={(e) => e.preventDefault()}
                onClick={() => {
                  uploadImgPosition.current = {
                    x: contextMenuComponent.x,
                    y: contextMenuComponent.y,
                  };
                  setShowLinkDialog(true);
                  setContextMenuComponent(null);
                }}
              >
                <ListItemIcon>
                  <AddLinkIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>
                  Add Link
                </ListItemText>
              </MenuItem>
              <MenuItem
                sx={{ py: py }}
                onContextMenu={(e) => e.preventDefault()}
                onClick={() => {
                  uploadImgPosition.current = {
                    x: contextMenuComponent.x,
                    y: contextMenuComponent.y,
                  };
                  setShowColorDialog(true);
                  setContextMenuComponent(null);
                }}
              >
                <ListItemIcon>
                  <PaletteIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>
                  Add Color
                </ListItemText>
              </MenuItem>
              <MenuItem
                sx={{ py: py }}
                onContextMenu={(e) => e.preventDefault()}
                onClick={() => {
                  uploadImgPosition.current = {
                    x: contextMenuComponent.x,
                    y: contextMenuComponent.y,
                  };
                  setShowTextDialog(true);
                  setContextMenuComponent(null);
                }}
              >
                <ListItemIcon>
                  <NotesIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: fontSize }}>
                  Add Text
                </ListItemText>
              </MenuItem>
            </MenuList>
          )}
        </Paper>
      </Html>
    );
  };

  const handleChangeMoodboardFile = async (item) => {
    try {
      window.history.replaceState("", "Moodboard", `${window.location.pathname}?id=${item.id}`);

      setTabValue("moodboard");
    } catch (err) {
      console.log(err);
    }
  };

  const handleRefresh = async () => {
    setRandomSeed(Math.random());
  };
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
      value: index,
    };
  }

  //console.log('sketchWidth', sketchWidth, 'sketchHeight', sketchHeight, 'deleteComponent', deleteComponent, 'components', components)
  return (
    <>
      <SuiBox mb={2} mt={-2.5} key={randomSeed}>
        <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={uploading}>
          <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
          <SuiTypography variant="h6" fontWeight="medium" color="info">
            Uploading supporting files...
          </SuiTypography>
        </Backdrop>
        <NewSharedBar
          type="moodboard"
          data={moodboardData}
          shareSessionRef={shareSessionRef}
          title={
            <SuiBox display="flex" justifyContent="center" alignItems="center">
              {editNameVisible ? (
                <div className="flex">
                  <input
                    defaultValue={moodboardData?.name}
                    ref={moodboardNameInputRef}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleChangeMoodboardName();
                      }
                    }}
                    className="font-serif"
                    autoFocus
                    style={{
                      outline: "none",
                      border: "none",
                      width: inputWidth + "ch",
                      fontSize: "1.25rem",
                      lineHeight: 1.375,
                      fontWeight: 700,
                    }}
                    onChange={(e) => setInputWidth(e.target?.value?.length)}
                    onBlur={handleChangeMoodboardName}
                  />
                </div>
              ) : (
                <SuiBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                  <Tooltip
                    title={canWrite && moodboardData?.mode != 2 ? "Click to change name" : ""}
                  >
                    <SuiTypography
                      variant="h5"
                      className="font-serif"
                      fontWeight="bold"
                      textTransform="none"
                      onClick={() =>
                        canWrite && moodboardData?.mode != 2 ? handleShowEditMoodboardName() : null
                      }
                    >
                      {moodboardData.name}
                    </SuiTypography>
                  </Tooltip>
                </SuiBox>
              )}

              {moodboardData?.collection?.id ? (
                <SuiTypography
                  component={canWrite ? Link : "div"}
                  color="secondary"
                  sx={{ ml: 2, "&:hover": { textDecoration: "underline" } }}
                  to={
                    sharedView && collectionPermission
                      ? `/shared-with-me/collections?id=${moodboardData?.collection?.id}`
                      : `/workspace/collections?id=${moodboardData?.collection?.id}`
                  }
                  className="font-serif"
                  fontWeight="bold"
                >
                  {moodboardData?.collection?.title}
                </SuiTypography>
              ) : null}
            </SuiBox>
          }
          handleRefreshSourceData={loadMoodBoard}
          extraAction={
            <PlayCircleIcon
              sx={{ cursor: "pointer", zIndex: 2 }}
              onClick={() => setTutorialVisible(true)}
              color="dark"
              fontSize="medium"
            />
          }
        />
      </SuiBox>
      <VersionDialog
        versionDialogVisible={versionDialogVisible}
        setVersionDialogVisible={setVersionDialogVisible}
        versionsArg={versions}
        dataArg={components}
        saveFunc={(newVersions, selectVersionData = null) => {
          setVersions(newVersions);
          if (selectVersionData) setComponents(selectVersionData);
          setIsDirty(true);
        }}
      />
      {showColorDialog ? (
        <ShowColorDialog
          moodboardData={moodboardData}
          selectedComponent={selectedComponent}
          showColorDialog={showColorDialog}
          setShowColorDialog={setShowColorDialog}
          updateComponent={updateComponent}
          addComponent={addComponent}
          setIsDirty={setIsDirty}
          setSelectedComponentId={setSelectedComponentId}
          uploadImgPosition={uploadImgPosition}
        />
      ) : null}
      <ShowLinkDialog />
      <ShowCropImageDialog />
      <ShowCaptionDialog />
      <ShowTextDialog />
      <ShowComments />
      <ShowZoom />
      <SimplePrompt promptConfig={promptConfig} setPromptConfig={setPromptConfig} />
      <SuiBox className="flex" sx={{ width: "100%" }} onKeyDown={keyPress}>
        <SuiBox
          sx={{
            pt: 2,
            pl: 2,
            pr: showArchived ? 0 : 2,
            position: "sticky",
            top: "0px",
            border: "1px groove rgba(210,214,218,0.1)",
            height: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            minWidth: { lg: 240, md: 240, sm: 170, xs: 170 },
            width: { lg: 240, md: 240, sm: 170, xs: 170 },
          }}
          onClick={() => {
            setContextMenuComponent(null);
          }}
          tabIndex="1"
        >
          <Tabs
            value={tabValue}
            onChange={(e, v) => setTabValue(v)}
            aria-label="icon position tabs example"
            sx={{ mb: 0.5 }}
          >
            <Tab
              icon={<DesktopWindowsOutlinedIcon fontSize="small" />}
              iconPosition="start"
              label={
                <SuiTypography
                  sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block" } }}
                >
                  Tools
                </SuiTypography>
              }
              sx={{ fontSize: 14 }}
              {...a11yProps("moodboard")}
            />
            <Tab
              icon={<FolderIcon fontSize="small" />}
              iconPosition="start"
              label={
                <SuiTypography
                  sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block" } }}
                >
                  Folder
                </SuiTypography>
              }
              sx={{ fontSize: 14 }}
              {...a11yProps("folder")}
            />
          </Tabs>
          <TabPanel value={tabValue} index={"moodboard"}>
            <Card sx={{ borderRadius: 1, zIndex: 2, boxShadow: ({ boxShadows: { md } }) => md }}>
              <SuiTypography
                variant="body1"
                sx={{ lineHeight: 1.6, backgroundColor: "#f3f3f3", px: 1 }}
              >
                Tools
              </SuiTypography>

              <Grid container>
                {selectedComponents.length === 0 && permission > 1 && (
                  <>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="moodboard-function-button-inactive"
                    >
                      <Tooltip
                        title={`You would drag images files straight into a Board or drag 'Add Image' button or click 'Add Image' button to upload images.`}
                        placement="right"
                      >
                        <SuiBox
                          className="flex justify-center"
                          sx={{ cursor: "pointer", mt: menuTop }}
                          draggable="true"
                          onDragStart={() => setDragType("image")}
                        >
                          <Upload
                            accept="image/*"
                            fileList={[]}
                            multiple
                            showUploadList={false}
                            customRequest={async (e1) => {
                              //await uploadImgFile(e1.file)
                            }}
                            beforeUpload={(e3) => {}}
                            onChange={async (e2) => {
                              if (e2.file.uid === e2.fileList[e2.fileList.length - 1].uid) {
                                for (var file of e2.fileList)
                                  await uploadImgFile(file.originFileObj, null, false);
                                setIsDirty(true);
                              }
                            }}
                          >
                            <SuiBox
                              ref={addImageRef}
                              onClick={(e) => {
                                if (dragType === null)
                                  uploadImgPosition.current = { x: -10000, y: -10000 };
                                setSelectedComponentId([]);
                              }}
                            >
                              <SuiBox className="flex justify-center">
                                <ImageIcon fontSize="small" />
                              </SuiBox>
                              <SuiBox className="flex justify-center">
                                <SuiTypography variant="body3">Add Image</SuiTypography>
                              </SuiBox>
                            </SuiBox>
                          </Upload>
                        </SuiBox>
                      </Tooltip>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="moodboard-function-button-inactive"
                    >
                      <Tooltip
                        title={`You would drag 'Add Link' button or click 'Add Link' button to add a image, youtube video, or spotify music.`}
                        placement="right"
                      >
                        <SuiBox
                          sx={{ cursor: "pointer", mt: menuTop }}
                          onClick={() => {
                            uploadImgPosition.current = { x: -10000, y: -10000 };
                            setSelectedComponentId([]);
                            setShowLinkDialog(true);
                          }}
                          draggable="true"
                          onDragStart={() => setDragType("link")}
                        >
                          <SuiBox className="flex justify-center">
                            <AddLinkIcon fontSize="small" />
                          </SuiBox>
                          <SuiBox className="flex justify-center">
                            <SuiTypography variant={menuFont}>Add Link</SuiTypography>
                          </SuiBox>
                        </SuiBox>
                      </Tooltip>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="moodboard-function-button-inactive"
                    >
                      <Tooltip
                        title={`You would drag 'Add Color' button or click 'Add Color' button to create color card.`}
                        placement="right"
                      >
                        <SuiBox
                          sx={{ cursor: "pointer", mt: menuTop }}
                          onClick={() => {
                            uploadImgPosition.current = { x: -10000, y: -10000 };
                            setSelectedComponentId([]);
                            setShowColorDialog(true);
                          }}
                          draggable="true"
                          onDragStart={() => setDragType("color")}
                        >
                          <SuiBox className="flex justify-center">
                            <PaletteIcon fontSize="small" />
                          </SuiBox>
                          <SuiBox className="flex justify-center">
                            <SuiTypography variant={menuFont}>Add Color</SuiTypography>
                          </SuiBox>
                        </SuiBox>
                      </Tooltip>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="moodboard-function-button-inactive"
                    >
                      <Tooltip
                        title={`You would drag 'Add Text' button or click 'Add Text' button to create text card.`}
                        placement="right"
                      >
                        <SuiBox
                          sx={{ cursor: "pointer", mt: menuTop }}
                          onClick={() => {
                            uploadImgPosition.current = { x: -10000, y: -10000 };
                            setSelectedComponentId([]);
                            setShowTextDialog(true);
                          }}
                          draggable="true"
                          onDragStart={() => setDragType("text")}
                        >
                          <SuiBox className="flex justify-center">
                            <NotesIcon fontSize="small" />
                          </SuiBox>
                          <SuiBox className="flex justify-center">
                            <SuiTypography variant={menuFont}>Add Text</SuiTypography>
                          </SuiBox>
                        </SuiBox>
                      </Tooltip>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="moodboard-function-button-inactive"
                    >
                      <Tooltip title={`Change background color.`} placement="right">
                        <SuiBox sx={{ mt: menuTop }}>
                          <SuiBox className="flex justify-center">
                            <input
                              type="color"
                              value={bgColor}
                              onChange={async (e) => {
                                var newColor = e.target.value.toUpperCase();
                                if (bgColor !== newColor) {
                                  setBgColor(newColor);
                                  setIsDirty(true);
                                }
                              }}
                            />
                          </SuiBox>
                          <SuiBox className="flex justify-center">
                            <SuiTypography sx={{ textAlign: "center" }} variant={menuFont}>
                              Background Color
                            </SuiTypography>
                          </SuiBox>
                        </SuiBox>
                      </Tooltip>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="moodboard-function-button-inactive"
                    >
                      <SuiBox
                        sx={{ cursor: "pointer", mt: menuTop }}
                        onClick={async () => {
                          setShowGridBg(!showGridBg);
                          setIsDirty(true);
                        }}
                      >
                        <SuiBox className="flex justify-center">
                          {showGridBg ? (
                            <GridOffIcon fontSize="small" />
                          ) : (
                            <GridOnIcon fontSize="small" />
                          )}
                        </SuiBox>
                        <SuiBox className="flex justify-center">
                          <SuiTypography variant={menuFont}>
                            {showGridBg ? "Hide" : "Show"} Grid
                          </SuiTypography>
                        </SuiBox>
                      </SuiBox>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="moodboard-function-button-inactive"
                    >
                      <SuiBox
                        sx={{ cursor: "pointer", mt: menuTop }}
                        onClick={async () => {
                          setShowArchived(!showArchived);
                        }}
                      >
                        <SuiBox className="flex justify-center">
                          <Badge
                            color="info"
                            badgeContent={archivedComponents.length}
                            size="small"
                            invisible={archivedComponents.length <= 0}
                            max={9}
                          >
                            <ArchiveIcon
                              fontSize="small"
                              sx={{ backgroundColor: showArchived ? "#BDBDBD" : bgcolor }}
                            />
                          </Badge>
                        </SuiBox>
                        <SuiBox className="flex justify-center">
                          <SuiTypography variant={menuFont}>
                            {showArchived ? "Hide" : ""} My Inspo
                          </SuiTypography>
                        </SuiBox>
                      </SuiBox>
                    </Grid>
                    {/* <SuiBox
                  sx={{ cursor: "pointer", mt: menuTop }}
                  onClick={async () => {
                    setShowAiDesign(!showAiDesign);
                  }}
                >
                  <SuiBox className="flex justify-center">
                    <Badge
                      color="info"
                      badgeContent={aiDesignComponents.length}
                      size="small"
                      invisible={aiDesignComponents.length <= 0}
                      max={9}
                    >
                      <DesignServicesIcon
                        fontSize="small"
                        sx={{ backgroundColor: showAiDesign ? "#BDBDBD" : bgcolor }}
                      />
                    </Badge>
                  </SuiBox>
                  <SuiBox className="flex justify-center">
                    <SuiTypography variant={menuFont}>
                      {showAiDesign ? "Hide" : ""} AI Designs
                    </SuiTypography>
                  </SuiBox>
                </SuiBox> */}

                    {user_id === moodboardData.owner_id && (
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        className="moodboard-function-button-inactive"
                      >
                        <Tooltip title="Version Control" placement="right">
                          <SuiBox
                            sx={{ cursor: "pointer", mt: menuTop }}
                            onClick={async () => {
                              setVersionDialogVisible(true);
                            }}
                          >
                            <SuiBox className="flex justify-center">
                              <TbVersions fontSize="30px" />
                            </SuiBox>
                            <SuiBox className="flex justify-center">
                              <SuiTypography variant={menuFont}>Versions</SuiTypography>
                            </SuiBox>
                          </SuiBox>
                        </Tooltip>
                      </Grid>
                    )}
                  </>
                )}

                {selectedComponents.length === 0 && permission > 0 && (
                  <>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="moodboard-function-button-inactive"
                    >
                      <SuiBox
                        sx={{ cursor: "pointer", mt: menuTop }}
                        onClick={() => {
                          handleExport();
                        }}
                      >
                        <SuiBox className="flex justify-center">
                          <DownloadIcon fontSize="small" />
                        </SuiBox>
                        <SuiBox className="flex justify-center">
                          <SuiTypography variant={menuFont}>Export</SuiTypography>
                        </SuiBox>
                      </SuiBox>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="moodboard-function-button-inactive"
                    >
                      <SuiBox
                        sx={{ cursor: "pointer", mt: menuTop, position: "relative" }}
                        onClick={(e) => {
                          setAnchorEl(null);
                          setAnchorZoomEl(
                            anchorZoomEl ? null : e.currentTarget.children[0].children[0]
                          );
                        }}
                      >
                        <SuiBox className="flex justify-center">
                          <ZoomInIcon
                            fontSize="small"
                            sx={{ backgroundColor: anchorZoomEl === null ? bgcolor : "#BDBDBD" }}
                          />
                        </SuiBox>
                        <SuiBox
                          aria-describedby={anchorZoomEl ? "zoom-popover" : undefined}
                          className="flex justify-center"
                        >
                          <SuiTypography variant={menuFont}>
                            Zoom {Math.floor(sketchScale * 100)}%
                          </SuiTypography>
                        </SuiBox>
                        {anchorZoomEl !== null && (
                          <div
                            className="flex items-center justify-center"
                            style={{
                              transform: "rotate(270deg)",
                              translate: "(-2px, 0.5px)",
                              position: "absolute",
                              top: "10px",
                              right: "18px",
                            }}
                          >
                            <svg
                              width="13"
                              height="8"
                              viewBox="0 0 13 8"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0 8 L6.5 0 L13 8"
                                fill="#FFFFFF"
                                stroke="none"
                                strokeWidth="1"
                                fill-rule="evenodd"
                              ></path>
                            </svg>
                          </div>
                        )}
                      </SuiBox>
                    </Grid>
                  </>
                )}

                {selectedComponent && (
                  <>
                    {" "}
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="moodboard-function-button-inactive"
                    >
                      <SuiBox
                        className="flex justify-center"
                        sx={{
                          cursor: "pointer",
                          mt: menuTop,
                          border: "1px solid #d2d6da",
                          py: 0.5,
                        }}
                        onClick={() => {
                          setSelectedComponentId([]);
                        }}
                      >
                        <KeyboardBackspaceIcon fontSize="small" />
                      </SuiBox>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="moodboard-function-button-inactive"
                    >
                      <SuiBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        height="100%"
                      >
                        <SuiTypography
                          variant="body1"
                          lineHeight="1"
                          sx={{
                            overflow: "hidden",
                            wordBreak: "break-all",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: "2",
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {selectedComponentText}
                        </SuiTypography>
                      </SuiBox>
                    </Grid>
                    {permission > 1 && <ComponentMenu component={selectedComponent} />}
                    {moodboard_id ? (
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        className="moodboard-function-button-inactive"
                      >
                        <SuiBox
                          sx={{ cursor: "pointer", mt: menuTop, position: "relative" }}
                          onClick={(e) => {
                            //console.log('e.currentTarget', e.currentTarget.children[0].children[0])
                            setAnchorEl(anchorEl ? null : e.currentTarget.children[0].children[0]);
                            setAnchorZoomEl(null);
                          }}
                        >
                          <SuiBox
                            aria-describedby={anchorEl ? "comments-popover" : undefined}
                            className="flex justify-center"
                          >
                            <CommentIcon
                              fontSize="small"
                              sx={{ backgroundColor: anchorEl === null ? bgcolor : "#BDBDBD" }}
                            />
                          </SuiBox>
                          <SuiBox className="flex justify-center">
                            <SuiTypography variant={menuFont}>Comments</SuiTypography>
                          </SuiBox>
                          {anchorEl !== null && (
                            <div
                              className="flex items-center justify-center"
                              style={{
                                transform: "rotate(270deg)",
                                translate: "(-2px, 0.5px)",
                                position: "absolute",
                                top: "10px",
                                right: "18px",
                              }}
                            >
                              <svg
                                width="13"
                                height="8"
                                viewBox="0 0 13 8"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M0 8 L6.5 0 L13 8"
                                  fill="#FFFFFF"
                                  stroke="none"
                                  strokeWidth="1"
                                  fill-rule="evenodd"
                                ></path>
                              </svg>
                            </div>
                          )}
                        </SuiBox>
                      </Grid>
                    ) : null}
                  </>
                )}

                {selectedComponents.length > 1 && (
                  <>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="moodboard-function-button-inactive"
                    >
                      <SuiBox className="flex justify-center" sx={{ my: 1 }}>
                        <SuiTypography
                          variant="h6"
                          lineHeight="1"
                          sx={{
                            overflow: "hidden",
                            wordBreak: "break-all",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: "2",
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {selectedComponents.length} Items
                        </SuiTypography>
                      </SuiBox>
                    </Grid>
                    {permission > 1 && (
                      <>
                        {selectedComponents.find(
                          (c) => c.type == "text" || (c.caption && c.caption.length > 0)
                        ) && (
                          <Grid
                            item
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            className="moodboard-function-button-inactive"
                          >
                            <SuiBox sx={{ mt: menuTop }}>
                              <SuiBox className="flex justify-center">
                                <input
                                  type="color"
                                  value={"#fffffe"} //ask zhi for why
                                  onChange={(e) => {
                                    var bgcolor = e.target.value.toUpperCase();
                                    var newObjs = components.map((c) => {
                                      if (
                                        selectedComponentId.includes(c.id) &&
                                        (c.type == "text" || (c.caption && c.caption.length > 0))
                                      )
                                        return { ...c, bgcolor: bgcolor };
                                      return c;
                                    });
                                    setComponents(newObjs);
                                    setIsDirty(true);
                                  }}
                                />
                              </SuiBox>
                              <SuiBox className="flex justify-center">
                                <SuiTypography variant={menuFont}>Caption Color</SuiTypography>
                              </SuiBox>
                            </SuiBox>
                          </Grid>
                        )}
                        {selectedComponents.find(
                          (c) =>
                            (c.type === "text" || (c.caption && c.caption.length > 0)) &&
                            c.bgcolor !== ""
                        ) && (
                          <Grid
                            item
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            className="moodboard-function-button-inactive"
                          >
                            <Tooltip
                              title="Clear color to make caption transparent"
                              placement="right"
                            >
                              <SuiBox
                                sx={{ cursor: "pointer", mt: menuTop }}
                                onClick={() => {
                                  var newObjs = components.map((c) => {
                                    if (
                                      selectedComponentId.includes(c.id) &&
                                      (c.type === "text" || (c.caption && c.caption.length > 0)) &&
                                      c.bgcolor !== ""
                                    )
                                      return { ...c, bgcolor: "" };
                                    return c;
                                  });
                                  setComponents(newObjs);
                                  setIsDirty(true);
                                }}
                              >
                                <SuiBox className="flex justify-center">
                                  <OpacityIcon fontSize="small" />
                                </SuiBox>
                                <SuiBox className="flex justify-center">
                                  <SuiTypography sx={{ textAlign: "center" }} variant={menuFont}>
                                    Make Caption Transparent
                                  </SuiTypography>
                                </SuiBox>
                              </SuiBox>
                            </Tooltip>
                          </Grid>
                        )}{" "}
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="moodboard-function-button-inactive"
                        >
                          <SuiBox
                            sx={{ cursor: "pointer", mt: menuTop }}
                            onClick={() => {
                              var minX = Math.min(...selectedComponents.map((c) => c.x));
                              var newObjs = components.map((c) => {
                                if (selectedComponentId.includes(c.id) && c.lock !== 1)
                                  return { ...c, x: minX };
                                return c;
                              });
                              setComponents(newObjs);
                              setIsDirty(true);
                            }}
                          >
                            <SuiBox className="flex justify-center">
                              <AlignHorizontalLeftIcon fontSize="small" />
                            </SuiBox>
                            <SuiBox className="flex justify-center">
                              <SuiTypography sx={{ textAlign: "center" }} variant={menuFont}>
                                Align Left
                              </SuiTypography>
                            </SuiBox>
                          </SuiBox>
                        </Grid>
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="moodboard-function-button-inactive"
                        >
                          <SuiBox
                            sx={{ cursor: "pointer", mt: menuTop }}
                            onClick={() => {
                              var midX =
                                (Math.max(...selectedComponents.map((c) => c.x + c.width)) +
                                  Math.min(...selectedComponents.map((c) => c.x))) /
                                2;
                              var newObjs = components.map((c) => {
                                if (selectedComponentId.includes(c.id) && c.lock !== 1)
                                  return {
                                    ...c,
                                    x:
                                      Math.round((midX - c.width / 2) / blockPixels) * blockPixels +
                                      1,
                                  };
                                return c;
                              });
                              setComponents(newObjs);
                              setIsDirty(true);
                            }}
                          >
                            <SuiBox className="flex justify-center">
                              <AlignHorizontalCenterIcon fontSize="small" />
                            </SuiBox>
                            <SuiBox className="flex justify-center">
                              <SuiTypography sx={{ textAlign: "center" }} variant={menuFont}>
                                Align Center
                              </SuiTypography>
                            </SuiBox>
                          </SuiBox>
                        </Grid>
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="moodboard-function-button-inactive"
                        >
                          <SuiBox
                            sx={{ cursor: "pointer", mt: menuTop }}
                            onClick={() => {
                              var maxXEnd = Math.max(
                                ...selectedComponents.map((c) => c.x + c.width)
                              );
                              var newObjs = components.map((c) => {
                                if (selectedComponentId.includes(c.id) && c.lock !== 1)
                                  return { ...c, x: maxXEnd - c.width };
                                return c;
                              });
                              setComponents(newObjs);
                              setIsDirty(true);
                            }}
                          >
                            <SuiBox className="flex justify-center">
                              <AlignHorizontalRightIcon fontSize="small" />
                            </SuiBox>
                            <SuiBox className="flex justify-center">
                              <SuiTypography sx={{ textAlign: "center" }} variant={menuFont}>
                                Align Right
                              </SuiTypography>
                            </SuiBox>
                          </SuiBox>
                        </Grid>
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="moodboard-function-button-inactive"
                        >
                          <SuiBox
                            sx={{ cursor: "pointer", mt: menuTop }}
                            onClick={() => {
                              var minY = Math.min(...selectedComponents.map((c) => c.y));
                              var newObjs = components.map((c) => {
                                if (selectedComponentId.includes(c.id) && c.lock !== 1)
                                  return { ...c, y: minY };
                                return c;
                              });
                              setComponents(newObjs);
                              setIsDirty(true);
                            }}
                          >
                            <SuiBox className="flex justify-center">
                              <AlignVerticalTopIcon fontSize="small" />
                            </SuiBox>
                            <SuiBox className="flex justify-center">
                              <SuiTypography sx={{ textAlign: "center" }} variant={menuFont}>
                                Align Top
                              </SuiTypography>
                            </SuiBox>
                          </SuiBox>
                        </Grid>
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="moodboard-function-button-inactive"
                        >
                          <SuiBox
                            sx={{ cursor: "pointer", mt: menuTop }}
                            onClick={() => {
                              var midY =
                                (Math.max(
                                  ...selectedComponents.map(
                                    (c) => c.y + c.height + (c.caption ? 60 : 0)
                                  )
                                ) +
                                  Math.min(...selectedComponents.map((c) => c.y))) /
                                2;
                              var newObjs = components.map((c) => {
                                if (selectedComponentId.includes(c.id) && c.lock !== 1)
                                  return {
                                    ...c,
                                    y:
                                      Math.round(
                                        (midY - (c.height + (c.caption ? 60 : 0)) / 2) / blockPixels
                                      ) *
                                        blockPixels +
                                      1,
                                  };
                                return c;
                              });
                              setComponents(newObjs);
                              setIsDirty(true);
                            }}
                          >
                            <SuiBox className="flex justify-center">
                              <AlignVerticalCenterIcon fontSize="small" />
                            </SuiBox>
                            <SuiBox className="flex justify-center">
                              <SuiTypography sx={{ textAlign: "center" }} variant={menuFont}>
                                Align Middle
                              </SuiTypography>
                            </SuiBox>
                          </SuiBox>
                        </Grid>
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="moodboard-function-button-inactive"
                        >
                          <SuiBox
                            sx={{ cursor: "pointer", mt: menuTop }}
                            onClick={() => {
                              var maxYEnd = Math.max(
                                ...selectedComponents.map(
                                  (c) => c.y + c.height + (c.caption ? 60 : 0)
                                )
                              );
                              var newObjs = components.map((c) => {
                                if (selectedComponentId.includes(c.id) && c.lock !== 1)
                                  return { ...c, y: maxYEnd - c.height - (c.caption ? 60 : 0) };
                                return c;
                              });
                              setComponents(newObjs);
                              setIsDirty(true);
                            }}
                          >
                            <SuiBox className="flex justify-center">
                              <AlignVerticalBottomIcon fontSize="small" />
                            </SuiBox>
                            <SuiBox className="flex justify-center">
                              <SuiTypography sx={{ textAlign: "center" }} variant={menuFont}>
                                Align Bottom
                              </SuiTypography>
                            </SuiBox>
                          </SuiBox>
                        </Grid>
                      </>
                    )}
                  </>
                )}
              </Grid>
            </Card>
          </TabPanel>
          <TabPanel value={tabValue} index={"folder"}>
            <MoodboardFileList
              handleClick={handleChangeMoodboardFile}
              currentItemId={moodboard_id}
              sharedView={sharedView}
              handleRefresh={handleRefresh}
            />
          </TabPanel>
        </SuiBox>
        {showArchived && (
          <ArchivedView
            archivedComponents={archivedComponents}
            setShowArchived={setShowArchived}
            exportImgRef={exportImgRef}
            areaHeight={areaHeight}
            bgcolor={bgcolor}
            setComponents={setComponents}
            setIsDirty={setIsDirty}
            setDragType={setDragType}
          />
        )}
        {showAiDesign && (
          <ArchivedView
            archivedComponents={aiDesignComponents}
            setShowArchived={setShowAiDesign}
            exportImgRef={exportImgRef}
            areaHeight={areaHeight}
            bgcolor={bgcolor}
            setComponents={setComponents}
            setIsDirty={setIsDirty}
            setDragType={setDragType}
          />
        )}
        <SuiBox
          ref={rightRef}
          tabIndex="0"
          sx={{
            border: "1px groove rgba(210,214,218,0.1)",
            height: areaHeight + 2,
            overflowX: "auto",
            overflowY: "auto",
            outline: "none",
          }}
        >
          <div
            onDrop={(e) => dropFile(e)}
            onDragOver={(e) => {
              e.preventDefault();
            }}
          >
            <Stage
              className="konva"
              ref={stageRef}
              width={sketchWidth * sketchScale}
              height={sketchHeight * sketchScale}
              scaleX={sketchScale}
              scaleY={sketchScale}
              onMouseDown={(e) => {
                //console.log('onMouseDown', e.evt, 'setContextMenuComponent')
                if (e.evt.button === 0) {
                  setContextMenuComponent(null);
                  var offsetX = e.evt.offsetX / sketchScale;
                  var offsetY = e.evt.offsetY / sketchScale;
                  var out = components.filter(
                    (c) =>
                      offsetX >= c.x &&
                      offsetX <= c.x + c.width &&
                      offsetY >=
                        c.y - (c.type == "music" || c.type == "video" ? dragHeaderHeight : 0) &&
                      offsetY <= c.y + c.height + (c.caption ? 60 : 0)
                  );
                  if (out.length == 0) {
                    setRangeSelection({ x: offsetX, y: offsetY });
                    setAnchorZoomEl(null);
                  }
                }
              }}
              onMouseMove={(e) => {
                if (!rangeSelection.x) return;
                setRangeSelection(handleRangeSelection(e.evt));
              }}
              onMouseUp={(e) => {
                if (!rangeSelection.x) return;
                handleRangeSelection(e.evt);
                setRangeSelection({});
              }}
              onContextMenu={(e) => {
                if (permission > 1) {
                  setContextMenuComponent({ x: e.evt.offsetX, y: e.evt.offsetY });
                  setSelectedComponentId([]);
                }
                e.evt.preventDefault();
              }}
            >
              <Layer>
                <Rect x={0} y={0} width={sketchWidth} height={sketchHeight} fill={bgColor} />
              </Layer>
              {showGridBg && <GridLayer width={sketchWidth} height={sketchHeight} />}
              <Layer>
                {components.map((component) => {
                  if (component.type === "image")
                    return (
                      <MBImage
                        key={component.id}
                        component={component}
                        updateComponent={updateComponent}
                        selectedComponentId={selectedComponentId}
                        setSelectedComponentId={setSelectedComponentId}
                        unLockfunc={unLockfunc}
                        deleteFunc={deleteFunc}
                        setShowDialog={setShowCropImageDialog}
                        permission={permission}
                        setContextMenuComponent={setContextMenuComponent}
                      />
                    );
                  if (component.type === "color")
                    return (
                      <MBColor
                        key={component.id}
                        component={component}
                        updateComponent={updateComponent}
                        selectedComponentId={selectedComponentId}
                        setSelectedComponentId={setSelectedComponentId}
                        unLockfunc={unLockfunc}
                        deleteFunc={deleteFunc}
                        setShowDialog={setShowColorDialog}
                        permission={permission}
                        setContextMenuComponent={setContextMenuComponent}
                      />
                    );
                  if (component.type === "text")
                    return (
                      <MBText
                        key={component.id}
                        component={component}
                        updateComponent={updateComponent}
                        selectedComponentId={selectedComponentId}
                        setSelectedComponentId={setSelectedComponentId}
                        unLockfunc={unLockfunc}
                        deleteFunc={deleteFunc}
                        setShowDialog={setShowTextDialog}
                        permission={permission}
                        setContextMenuComponent={setContextMenuComponent}
                      />
                    );
                  if (component.type === "video")
                    return (
                      <MBVideo
                        key={component.id}
                        component={component}
                        updateComponent={updateComponent}
                        selectedComponentId={selectedComponentId}
                        setSelectedComponentId={setSelectedComponentId}
                        unLockfunc={unLockfunc}
                        deleteFunc={deleteFunc}
                        permission={permission}
                        setContextMenuComponent={setContextMenuComponent}
                      />
                    );
                  if (component.type === "music")
                    return (
                      <MBMusic
                        key={component.id}
                        component={component}
                        updateComponent={updateComponent}
                        selectedComponentId={selectedComponentId}
                        setSelectedComponentId={setSelectedComponentId}
                        unLockfunc={unLockfunc}
                        deleteFunc={deleteFunc}
                        permission={permission}
                        setContextMenuComponent={setContextMenuComponent}
                      />
                    );
                  return <></>;
                })}
                {contextMenuComponent && <ComponentContextMenu />}
              </Layer>
              {rangeSelection.ex && (
                <Layer>
                  <Rect
                    x={rangeSelection.sx}
                    y={rangeSelection.sy}
                    width={rangeSelection.ex - rangeSelection.sx}
                    height={rangeSelection.ey - rangeSelection.sy}
                    fill={"grey"}
                    opacity={0.2}
                  />
                </Layer>
              )}
            </Stage>
          </div>
        </SuiBox>
        <div style={{ position: "absolute", top: "-10000px", right: "-10000px" }}>
          <SuiBox ref={imgRef} id={"exportmoodboard"} style={{ width: bwidth, height: bheight }}>
            <Stage className="konva" width={bwidth} height={bheight}>
              <Layer>
                <Rect x={0} y={0} width={bwidth} height={bheight} fill={bgColor} />
                {bcomponents.map((component) => {
                  if (component.type === "image")
                    return (
                      <MBImage
                        key={component.id}
                        component={component}
                        exportImgRef={exportImgRef}
                      />
                    );
                  if (component.type === "color")
                    return (
                      <MBColor
                        key={component.id}
                        component={component}
                        exportImgRef={exportImgRef}
                      />
                    );
                  if (component.type === "text")
                    return (
                      <MBText
                        key={component.id}
                        component={component}
                        exportImgRef={exportImgRef}
                      />
                    );
                  if (component.type === "video")
                    return (
                      <MBVideo
                        key={component.id}
                        component={component}
                        exportImgRef={exportImgRef}
                        exportFlag={true}
                      />
                    );
                  if (component.type === "music")
                    return (
                      <MBMusic
                        key={component.id}
                        component={component}
                        exportImgRef={exportImgRef}
                        exportFlag={true}
                      />
                    );
                  return <></>;
                })}
              </Layer>
            </Stage>
          </SuiBox>
        </div>
      </SuiBox>
      {tutorialVisible ? (
        <MoodboardPageTutorialModal
          visible={tutorialVisible}
          handleClose={() => setTutorialVisible(false)}
        />
      ) : null}
    </>
  );
};

export default Moodboard;
